import { FC } from 'react';

import { IconContainer } from '../IconContainer';
import { IconProps } from '../types';

export const Bus20: FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className,
  style,
  svgClassName,
  svgStyle,
  ariaLabel,
  onClick,
}) => {
  return (
    <IconContainer
      size={size}
      className={className}
      style={style}
      ariaLabel={ariaLabel}
      onClick={onClick}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={svgClassName}
        style={svgStyle}
      >
        <path d="M10.0029 3.33325C13.3361 3.33331 15.8359 4.22583 15.8359 4.22583V7.50024H16.6689V10.0002L15.8359 10.8333V16.6663H15.0029C14.5429 16.6663 14.1689 16.2933 14.1689 15.8333H5.83594C5.83594 16.2931 5.46278 16.6661 5.00293 16.6663H4.16895V10.8333L3.33594 10.0002V7.50024H4.16895V4.22583C4.16895 4.22583 6.6696 3.33325 10.0029 3.33325ZM6.66895 12.5002C6.2091 12.5004 5.83594 12.8734 5.83594 13.3333C5.83594 13.7931 6.20909 14.1661 6.66895 14.1663C7.12895 14.1663 7.50293 13.7933 7.50293 13.3333C7.50293 12.8733 7.12895 12.5002 6.66895 12.5002ZM13.3359 12.5002C12.8759 12.5002 12.5029 12.8733 12.5029 13.3333C12.5029 13.7933 12.8759 14.1663 13.3359 14.1663C13.7959 14.1663 14.1689 13.7933 14.1689 13.3333C14.1689 12.8733 13.7959 12.5002 13.3359 12.5002ZM5.83594 6.66626V10.0002C5.83611 10.46 6.2092 10.8331 6.66895 10.8333H13.3359C13.7958 10.8333 14.1688 10.4601 14.1689 10.0002V6.66626H5.83594ZM8.33594 5.00024V5.83325H11.6689V5.00024H8.33594Z" fill={color} />
      </svg>
    </IconContainer>
  );
};
